import React, { useEffect, useState } from "react";
import API from "../utils/api";
import Swal from "sweetalert2";
import bgImage from "../assets/airmax.webp"; // adjust if needed

const Debts = () => {
  const [debts, setDebts] = useState([]);

  const fetchDebts = async () => {
    try {
      const res = await API.get("/debts.php");
      setDebts(res.data);
    } catch {
      Swal.fire("Error", "Failed to load debts", "error");
    }
  };

  const markAsPaid = async (id) => {
    const confirm = await Swal.fire({
      title: "Mark as Paid?",
      text: "Confirm that the customer has paid.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, mark paid",
    });

    if (!confirm.isConfirmed) return;

    try {
      await API.put("/debts.php", { id });
      Swal.fire("✅ Success", "Debt marked as paid", "success");
      fetchDebts();
    } catch (err) {
      Swal.fire("❌ Error", err.response?.data?.error || "Failed to update", "error");
    }
  };

  useEffect(() => {
    fetchDebts();
  }, []);

  return (
    <div className="w-full h-full relative overflow-y-auto">
      {/* 🔲 Background */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30 blur-sm"
        style={{ backgroundImage: `url(${bgImage})` }}
      ></div>

      {/* 🎯 Foreground Content */}
      <div className="relative z-10 p-6">
        <div className="bg-white/90 backdrop-blur-md rounded-xl shadow-md p-6 max-w-6xl mx-auto">
          <h2 className="text-2xl font-semibold text-gray-800 mb-6">
            💳 Unpaid Customer Debts
          </h2>

          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left border border-gray-200">
              <thead className="bg-gray-100 text-gray-700 font-medium">
                <tr>
                  <th className="px-4 py-3">Customer</th>
                  <th className="px-4 py-3">Phone</th>
                  <th className="px-4 py-3">Amount</th>
                  <th className="px-4 py-3">Date</th>
                  <th className="px-4 py-3">Action</th>
                </tr>
              </thead>
              <tbody className="text-gray-700">
                {debts.length > 0 ? (
                  debts.map((d) => (
                    <tr key={d.id} className="border-t hover:bg-gray-50">
                      <td className="px-4 py-2">{d.customer_name}</td>
                      <td className="px-4 py-2">{d.phone}</td>
                      <td className="px-4 py-2">${d.amount}</td>
                      <td className="px-4 py-2">
                        {new Date(d.sold_at).toLocaleDateString()}
                      </td>
                      <td className="px-4 py-2">
                        <button
                          onClick={() => markAsPaid(d.id)}
                          className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded transition"
                        >
                          Mark Paid
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center px-4 py-6 text-gray-500">
                      No unpaid debts found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Debts;
